import * as React from 'react';
import { makeStyles, createStyles, Theme, Box, Typography } from '@material-ui/core';
import InfoTooltip from '../../../components/InfoTooltip/InfoTooltip';
import InformationIcon from '../../../assets/icons/InformationIcon';

export interface NewPaymentTermsRowType {
  label: string;
  value?: string;
  tooltip?: {
    title: string;
    text: string;
  }
}

interface NewPaymentTermsRowsProps {
  className?: string;
  rows: NewPaymentTermsRowType[];
}

export const NewPaymentTermsRows: React.FC<NewPaymentTermsRowsProps> = ({ rows, className }) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <Box className={className} data-testid="new-payment-terms__box">
      {rows.map(({ label, value, tooltip }) => {
        return (
          <Box className={classes.newTerm} key={`${label}`}>
            <Typography className={classes.newTermOutTitle}>{label}</Typography>
            <Typography className={classes.newTermOutText} data-testid={`new-payment-terms__${label}`}>
              {tooltip && (
                <InfoTooltip
                  className={classes.newTermInfoIcon}
                  title={tooltip.title}
                  text={tooltip.text}
                >
                  <Box component="span">
                    <InformationIcon className={classes.icon} size={16} />
                  </Box>
                </InfoTooltip>
              )}
              {value}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => createStyles({
  newTerm: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-betweem',
    alignItems: 'center',
    margin: theme.spacing(0.6, 0),
  },
  newTermOutTitle: {
    ...theme.typography.body2,
    color: theme.palette.text5.main,
    textTransform: 'uppercase',
    margin: 'auto',
    marginLeft: 0,
  },
  newTermOutText: {
    ...theme.typography.body1,
    color: theme.palette.indigo.main,
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    textAlign: 'right',
    lineHeight: 1.2,
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
    },
  },
  newTermInfoIcon: {
    display: 'flex',
  },
  icon: {
    color: theme.palette.lavender.main,
    marginInlineEnd: theme.spacing(0.5),
  },
}));
